import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _bulkArchiveReservationsRequest = {};
var _bulkArchiveReservationsResponse = {};
var _bulkUnArchiveReservationsRequest = {};
var _bulkUnArchiveReservationsResponse = {};
var _cancelReservationRequest = {};
var _cancelReservationResponse = { reservation: '_reservation' };
var _createHeldReservationRequest = {
    reservationDetails: '_heldReservationDetails',
};
var _createHeldReservationResponse = { reservation: '_reservation' };
var _createReservationRequest = { reservation: '_reservation' };
var _createReservationResponse = { reservation: '_reservation' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deleteReservationRequest = {};
var _deleteReservationResponse = {};
var _details = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _getReservationRequest = {};
var _getReservationResponse = { reservation: '_reservation' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _heldReservationDetails = { startDate: 'google.protobuf.Timestamp' };
var _listReservationsRequest = {
    startDateFrom: 'google.protobuf.Timestamp',
    startDateTo: 'google.protobuf.Timestamp',
};
var _listReservationsResponse = { reservations: '_reservation' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryReservationsRequest = {};
var _queryReservationsResponse = { reservations: '_reservation' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _rawHttpRequest = { body: 'BYTES' };
var _rawHttpResponse = { body: 'BYTES' };
var _reservation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    details: '_details',
};
var _reserveReservationRequest = {};
var _reserveReservationResponse = { reservation: '_reservation' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchReservationsRequest = { search: '_cursorSearch' };
var _searchReservationsResponse = {
    reservations: '_reservation',
    aggregationData: '_aggregationData',
};
var _updateReservationRequest = {
    mask: 'google.protobuf.FieldMask',
    reservation: '_reservation',
};
var _updateReservationResponse = { reservation: '_reservation' };
function resolveWixTableReservationsReservationV1ReservationsServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/table-reservations/reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/table-reservations/reservations',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new reservation.
 *
 * `Create Reservation` accepts and requires different fields depending on the `status` and `source` specified, and the permissions of the [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) you're authenticated as.
 *
 * ### Status and source
 *
 * If a `status` is not specified, it will be set to:
 * * `RESERVED` if manual approval is not required for confirmation
 * * `REQUESTED` if manual approval is required for confirmation.
 *
 * A reservation created with any `source` other than `WALK_IN` requires the `reservation.reservee.phone` and `reservation.reservee.firstName` fields.
 * Attempting to create a reservation without these fields results in an error.
 *
 * ### Permissions
 *
 * The fields `status`, `source`, `reservation.details.tableIds`, `reservation.details.endDate`, `ignoreReservationLocationConflicts`, and `ignoreTableCombinationConflicts` should only be specified if you're authenticated as an [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) with the `MANAGE RESERVATIONS (FULL)` permission scope.
 * Specifying these fields without the required permissions results in an application error.
 *
 * If `source` is not specified, its value is set depending on the permissions of the permissions of the [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) you're authenticated as.
 * If the identity has the `MANAGE RESERVATIONS (FULL)` permission scope the `source` is set to `UNDEFINED`. Otherwise, the `source` is set to `ONLINE`.
 *
 * >**Note:** `Create Reservation` requires all details of the reservation upfront. The process of creating a reservation can be broken up using `Create Held Reservation`. `Create Held Reservation` creates a temporary reservation that expires automatically unless it is completed with the addition of more details using `Reserve Reservation`.
 */
export function createReservation(payload) {
    var _a = serializer(_createReservationRequest, { _details: _details, _reservation: _reservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __createReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.CreateReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReservation.fromReq = fromReq;
    __createReservation.__isAmbassador = true;
    return __createReservation;
}
/**
 * Retrieves a reservation.
 *
 * You can only retrieve the `FULL` fieldset if the [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) you're authenticated as has the `MANAGE RESERVATIONS (MEDIUM)` or `MANAGE RESERVATIONS (FULL)` permission scopes.
 */
export function getReservation(payload) {
    var _a = serializer(_getReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __getReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'GET',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.GetReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/{reservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReservation.fromReq = fromReq;
    __getReservation.__isAmbassador = true;
    return __getReservation;
}
/**
 * Updates a reservation.
 *
 * The fields `status`, `source`, `reservation.details.tableIds`, `reservation.details.endDate`, `ignoreReservationLocationConflicts`, and `ignoreTableCombinationConflicts` should only be specified in the request if the identity you're authenticated as has the `MANAGE RESERVATIONS (FULL)` permission scope.
 * Including these fields in the request without the required permissions results in an application error.
 *
 * Each time the reservation is updated, revision increments by 1. The existing revision must be specified when updating the reservation. This ensures you're working with the latest reservation information, and it prevents unintended overwrites.
 */
export function updateReservation(payload) {
    var _a = serializer(_updateReservationRequest, { _details: _details, _reservation: _reservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __updateReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'PATCH',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.UpdateReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/{reservation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReservation.fromReq = fromReq;
    __updateReservation.__isAmbassador = true;
    return __updateReservation;
}
/**
 * Creates a new temporary reservation and holds it for the customer for 10 minutes.
 *
 * Creates a new reservation with the `HELD` status. `HELD` reservations are intended to reserve seats and tables for a party in a selected time slot while they enter further reservation details, such as names and contact information. Reservations with the `HELD` status are only valid for 10 minutes. Trying to change a `HELD` reservation’s status after 10 minutes returns an error.
 *
 * You cannot call `Update Reservation` to change a reservation’s status from `HELD`. Trying to do so returns an error. Instead, you should use `Reserve Reservation`.
 *
 * If you do not wish to have `HELD` reservations in your flow, you can create a reservation with all required details using `Create Reservation`.
 */
export function createHeldReservation(payload) {
    var _a = serializer(_createHeldReservationRequest, { _heldReservationDetails: _heldReservationDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createHeldReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __createHeldReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.CreateHeldReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/hold',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createHeldReservation.fromReq = fromReq;
    __createHeldReservation.__isAmbassador = true;
    return __createHeldReservation;
}
/**
 * Reserves or requests a held reservation.
 *
 * Held reservations are temporary reservations with the `HELD` status created by `Create Held Reservation`.
 * They are intended to reserve seats and tables for a party in a selected time slot while they enter further reservation details, such as names and contact information. Reservations with the `HELD` status are only valid for 10 minutes. Trying to call `Reserve Reservation` with a held reservation older than 10 minutes returns an error.
 *
 * `Reserve Reservation` changes a reservation's `HELD` status to:
 * * `RESERVED` if the reservation's reservation location does not require manual approval.
 * * `REQUESTED` if the reservation's reservation location requires manual approval.
 */
export function reserveReservation(payload) {
    var _a = serializer(_reserveReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reserveReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __reserveReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.ReserveReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/{reservationId}/reserve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reserveReservation.fromReq = fromReq;
    __reserveReservation.__isAmbassador = true;
    return __reserveReservation;
}
/**
 * Cancels a reservation.
 *
 * Sets the reservation status to `CANCELED`.
 */
export function cancelReservation(payload) {
    var _a = serializer(_cancelReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelReservationResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __cancelReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.CancelReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/{reservationId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelReservation.fromReq = fromReq;
    __cancelReservation.__isAmbassador = true;
    return __cancelReservation;
}
/** Deletes a reservation. Only reservations with the `HELD` status can be deleted. */
export function deleteReservation(payload) {
    var _a = serializer(_deleteReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteReservationResponse, {}).fromJSON;
    function __deleteReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'DELETE',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.DeleteReservation',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/{reservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReservation.fromReq = fromReq;
    __deleteReservation.__isAmbassador = true;
    return __deleteReservation;
}
/** Retrieves a list of up to 100 reservations. */
export function listReservations(payload) {
    var _a = serializer(_listReservationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listReservationsResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __listReservations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'GET',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.ListReservations',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listReservations.fromReq = fromReq;
    __listReservations.__isAmbassador = true;
    return __listReservations;
}
/**
 * Retrieves a list of reservations given the provided paging, filtering, and sorting. Up to 100 reservations can be returned per request.
 *
 * For a detailed list of supported operations, see the [Sorting, Filtering, and Search](https://dev.wix.com/docs/rest/api-reference/wix-restaurants/reservations/reservations/sorting-filtering-and-search) article.
 * To learn how to query reservations, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryReservations(payload) {
    var _a = serializer(_queryReservationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReservationsResponse, {
        _details: _details,
        _reservation: _reservation,
    }).fromJSON;
    function __queryReservations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.QueryReservations',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReservations.fromReq = fromReq;
    __queryReservations.__isAmbassador = true;
    return __queryReservations;
}
/**
 * Use this method to search the fields of the table reservations on a site for a given expression.
 *
 * You can also use this method to perform data aggregations on a site's table reservation fields.
 * For a detailed list of supported operations, see the [Sorting, Filtering, and Search](https://dev.wix.com/docs/rest/api-reference/wix-restaurants/reservations/reservations/sorting-filtering-and-search) article.
 */
export function searchReservations(payload) {
    var _a = serializer(_searchReservationsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchReservationsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _details: _details,
        _groupByValueResults: _groupByValueResults,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _reservation: _reservation,
        _results: _results,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchReservations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.SearchReservations',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchReservations.fromReq = fromReq;
    __searchReservations.__isAmbassador = true;
    return __searchReservations;
}
/** Bulk archive reservations. */
export function bulkArchiveReservations(payload) {
    var _a = serializer(_bulkArchiveReservationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveReservationsResponse, {}).fromJSON;
    function __bulkArchiveReservations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.BulkArchiveReservations',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/bulk/reservations/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveReservations.fromReq = fromReq;
    __bulkArchiveReservations.__isAmbassador = true;
    return __bulkArchiveReservations;
}
/** Bulk unarchive reservations. */
export function bulkUnArchiveReservations(payload) {
    var _a = serializer(_bulkUnArchiveReservationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnArchiveReservationsResponse, {}).fromJSON;
    function __bulkUnArchiveReservations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.BulkUnArchiveReservations',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/bulk/reservations/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnArchiveReservations.fromReq = fromReq;
    __bulkUnArchiveReservations.__isAmbassador = true;
    return __bulkUnArchiveReservations;
}
/**
 * Get calendar invite file
 * Returns FILE_NOT_FOUND if the file has expired or does not exist.
 */
export function getCalendarInviteFileWebhook(payload) {
    var _a = serializer(_rawHttpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __getCalendarInviteFileWebhook(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation',
            method: 'GET',
            methodFqn: 'wix.table_reservations.reservation.v1.ReservationsService.GetCalendarInviteFileWebhook',
            url: resolveWixTableReservationsReservationV1ReservationsServiceUrl({
                protoPath: '/v1/reservations/calendar-invite-files/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCalendarInviteFileWebhook.fromReq = fromReq;
    __getCalendarInviteFileWebhook.__isAmbassador = true;
    return __getCalendarInviteFileWebhook;
}
//# sourceMappingURL=http.impl.js.map